module.exports = __webpack_public_path__ + "img/phone.49082db6.png";